/** @typedef {import('../server/config/schema').Config} Config */

const isServer = typeof window === 'undefined';

// Єдиний config: сервер — повний global.APP_CONFIG; клієнт — client:true-зріз (window.APP_CONFIG).
/** @type {Config} */
// eslint-disable-next-line import/prefer-default-export
export const config = isServer ? global.APP_CONFIG : window.APP_CONFIG;
